<template>
  <v-card>
    <div class="d-flex">
      <div class="pa-4">
        <ProductTcoCard v-bind:product="productSelected" :showBtn="false" />
      </div>
      <div>
        <v-card-title class="text-center text-h2 primary--text line-height-13">
          {{ $t("tco.perks.blocks.tcoProduct.products.modal.title") }}
        </v-card-title>
        <v-card-text class="primary--text text-body-1">
          {{
            $t("tco.perks.blocks.tcoProduct.products.modal.text", {
              date: getApplicationConfig.TCO_END_DATE
            })
          }}
        </v-card-text>
        <div
          class="d-flex w-100 text-h2 line-height-13 pa-2"
          v-if="promoProductsTcoToChoose"
        >
          <span class="products-recap"
            >{{ promoProductsTco.length }}/{{ promoProductsTcoToChoose }}</span
          ><span class="products-recap-text pl-2">completati</span>
        </div>
        <template v-if="promoProductsTcoToChoose && promoProductsTco">
          <div class="d-flex w-100 px-2">
            <v-icon
              v-for="(product, index) in promoProductsTco"
              :key="'promo-' + index"
              class="dot-full"
              :class="{ 'px-2': index != 0 || index != 4 }"
            >
              $delimiter
            </v-icon>
            <v-icon
              v-for="index in promoProductsTcoToChoose -
                promoProductsTco.length"
              :key="'radio-off-' + index"
              class="dot-empty"
              :class="{ 'px-2': index != 0 || index != 4 }"
            >
              $radioOff
            </v-icon>
          </div>
        </template>
      </div>
    </div>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn outlined color="primary" @click="cancel()">
        {{ $t("tco.perks.blocks.tcoProduct.products.modal.cancelBtn") }}
      </v-btn>
      <v-btn color="primary" depressed @click="submit()">
        {{ $t("tco.perks.blocks.tcoProduct.products.modal.confirmBtn") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<style lang="scss" scoped>
.products-recap {
  font-size: 36px !important;
  display: flex;
  align-items: flex-end;
  color: var(--v-promo-darken2) !important;
}
.products-recap-text {
  display: flex;
  align-items: flex-end;
  color: var(--v-promo-darken2) !important;
  margin-bottom: 5px;
}
.dot-full,
.dot-empty {
  font-size: 14px;
  color: var(--v-promo-darken2) !important;
}
</style>
<script>
import ProductTcoCard from "@/components/cardOro/ProductTcoCard.vue";

import { mapGetters } from "vuex";

export default {
  name: "TcoProductsModalConfirm",
  components: {
    ProductTcoCard
  },
  data() {
    return {};
  },
  props: {
    productSelected: { type: Object, required: true },
    promoProductsTco: { type: Array, default: () => [] },
    promoProductsTcoToChoose: { type: Number, default: null }
  },
  computed: {
    ...mapGetters({
      getApplicationConfig: "custom/getApplicationConfig"
    })
  },
  methods: {
    submit() {
      this.$emit("submit", true);
    },
    cancel() {
      this.$emit("submit", false);
    }
  },
  mounted() {}
};
</script>
